<template>
	<c-dialog ref="dialog" width="500" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item :label="title">
				<c-input name="progress" disabled></c-input>
			</c-form-item>
			<c-form-item label="数量" required>
				<c-input type="number" name="product_count" decimal="6" :range="[0.01,99999999]" :append-text="aux_unit"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" maxlength="500"></c-input>
			</c-form-item>
			<c-form-item label="附件">
				<c-upload-file name="attachment_file_url" v-model="attachment_file_url" type="image" size="5120" button="选择文件"></c-upload-file>
			</c-form-item>
			<c-form-item v-if="show_batch_remark" label="批次备注">
				<c-input name="batch_remark" maxlength="255" placeholder="选填，将写入本次收货自动生成的库存批次备注"></c-input>
			</c-form-item>
            <!--自定义字段控件-->
            <custom-form ref="customForm" work-type="35"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'out_sourcing_order_process_edit',

	data() {
		return {
			out_sourcing_order_id:0,
			progress_type:0,
			title:'',
			attachment_file_url:'',
			aux_unit:'',
			show_batch_remark:false //是否显示批次备注录入（委外收货且开启成品自动入库且为批次库存模式）
		}
	},

	computed: {
		...mapState(['systemConfig'])
	},

	methods: {
		/**
		 * 打开发货 、收货框
		 * @param data      外协单信息
		 * @param type      类型 1：发货  2：收货
		 */
		open(data,type) {
			this._editState = !!data.processInfo;
			this.out_sourcing_order_id = data.id;
			this.$refs.form.clear();
            //自定义字段控件初始化
            this.$refs.customForm.init();
			this.aux_unit = data.unit;
			this.aux_unit_id = data.unit_id;
			var formData = data.processInfo||{};
			if (type == 1){
				this.progress_type = 1;
				this.title = '发货进度';
				formData.progress = data.send_count+ " / " +data.plan_count;
			}else {
				this.progress_type = 2;
				this.title = '收货进度';
				formData.progress = data.receive_count+ " / " +data.plan_count;
			}
			//委外收货且关联任务开启成品自动入库、且为批次库存模式时，可录入批次备注（写入本次收货自动生成的新库存批次）
			this.show_batch_remark = (type == 2 && !this._editState && data.product_auto_in == 1 && this.systemConfig.batch_stock == 1);
			this.$refs.form.set(formData);
			//填充form表单
			this.$refs.dialog.open({
				title: type==1?'发货':'收货'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/out/sourcing/order/edit/progress':'/out/sourcing/order/add/progress',
				rule: {
					product_count: '请输入'+(this.progress_type==1?'发货':'收货')+'数量',
                    ...this.$refs.customForm.rule
                },
				dataFormatter: data => {
					data.aux_unit_id = this.aux_unit_id;
					data.progress_type = this.progress_type;
					data.out_sourcing_order_id = this.out_sourcing_order_id;
					data.attachment_file_url = this.attachment_file_url;
                    data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
                    return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: (this.progress_type==1?'发货':'收货')+'成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>